function OnsiteSettingsService($location, $q, $resource, $rootScope) {

    var onsiteSettingsResource = $resource('/api/onsiteSettings/:id', {id: '@id'}, {
            update: {method: "PATCH"}
        }),
        logUserConfigsResource = $resource('/api/logUserConfigs/:id', {id: '@id'}, {
            update: {method: "PATCH"}
        }),
        dataTypesResource = $resource('/api/dataTypes/:id', {id: '@id'});



    this.getOnSiteSettingsByLogId = function (logId) {
        var deferred = $q.defer();

        onsiteSettingsResource.get({logId: logId}).$promise.then(function (ret) {
            var settings = ret._embedded.onsiteSettings.length === 1 ?
                ret._embedded.onsiteSettings[0] :
                {logId: logId, phoneNumber: null};
            deferred.resolve(settings);
        });
        return deferred.promise;
    };

    this.getLogUserConfigsByLogId = function(logId) {
        var deferred = $q.defer();

        logUserConfigsResource.get({logId: logId, userDetails: $rootScope.user.id}).$promise.then(function (ret) {
            var configs = { OnsiteSounds: {value: true} };

            for ( var i = 0; i < ret._embedded.logUserConfigs.length; i++) {
                var c = ret._embedded.logUserConfigs[i];
                if(c.userId === $rootScope.user.id) {
                    configs[c.key] = {
                        id: c.id,
                        key: c.key,
                        value: c.dataType.id === 1 ? c.value === 'true' : c.value,
                        dataTypeId: c.dataType.id,
                        obj: c
                    };
                }
            }
            deferred.resolve(configs);
        });
        return deferred.promise;
    };

    this.addSettings = function (settings) {
        settings.log = $rootScope.selectedLog._links.self.href;
        settings.logBookUserId = 0;
        return onsiteSettingsResource.save(settings);
    };

    this.updateSettings = function (settings) {
        return onsiteSettingsResource.update({
            id: settings.id
        }, {
            phoneNumber: settings.phoneNumber,
            levelOneWarning: settings.levelOneWarning,
            levelTwoWarning: settings.levelTwoWarning
        });
    };

    this.addSoundConfig = function(onsiteSounds){
        var deferred = $q.defer(),
            baseUrl = $location.absUrl().split("#")[0];

        dataTypesResource.get({id: 1}).$promise.then(function(dataType){
            onsiteSounds.log = $rootScope.selectedLog._links.self.href;
            onsiteSounds.dataType = dataType._links.self.href;
            onsiteSounds.userDetails = baseUrl + "api/logBookUserDetails/" + $rootScope.user.id;
            logUserConfigsResource.save(onsiteSounds).$promise.then(function(ret){
                deferred.resolve({
                    id: ret.id,
                    key: ret.key,
                    value: ret._embedded.dataType.id === 1 ?  ret.value === 'true' : ret.value,
                    dataTypeId: ret._embedded.dataType.id,
                    obj: ret
                });
            });
        });

        return deferred.promise;
    };

    this.updateSoundConfig = function(onsiteSounds){
        var deferred = $q.defer();

        logUserConfigsResource.update({
            id: onsiteSounds.id
        }, {
            value: onsiteSounds.value
        }).$promise.then(function(ret) {
            deferred.resolve({
                id: ret.id,
                key: ret.key,
                value: ret._embedded.dataType.id === 1 ?  ret.value === 'true' : ret.value,
                dataTypeId: ret._embedded.dataType.id,
                obj: ret
            });
        });

        return deferred.promise;
    };
}

angular.module("onsite").service("onsiteSettingsService", ["$location", "$q", "$resource", "$rootScope", OnsiteSettingsService]);
